const isCoinSportNotification = (data: WorkerNotification["data"]) =>
  data.link?.includes("coin-sport") || data.title?.includes("CoinSport");

export default isCoinSportNotification;
